<template>
  <c-loading-area :loading="loading">
    <v-card-title>
      {{ $t('page.manageFiling.origCourt.stepSummary.title') }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t('page.manageFiling.origCourt.stepSummary.description') }}
    </v-card-subtitle>
    <v-card-text class="pt-2">
      <dl class="d-grid grid-4060">
        <dt>{{ $t('page.manageFiling.origCourt.stepCase.field.originatingCourt') }}</dt>
        <dd>{{ bean.case.originatingCourt.courtName }}</dd>
        <dt>{{ $t('page.manageFiling.origCourt.stepCase.field.caseNumber') }}</dt>
        <dd>{{ bean.case.caseNumber }}</dd>
        <template v-if="hasCaseTitle">
          <dt>{{ $t('page.manageFiling.origCourt.stepCase.field.caseTitle') }}</dt>
          <dd>{{ bean.case.caseTitle }}</dd>
        </template>
        <template v-if="hasJudgments">
          <dt>{{ $t('page.manageFiling.origCourt.stepSummary.field.judgments') }}</dt>
          <dd v-for="(judgment, index) in bean.judgments"
              :key="`judgment-${index}`">
            <div v-if="hasJudgmentText(judgment)">
              {{ generateJudgmentText(judgment.judge, getJudgmentTypeName(judgment)) }}
            </div>
            <div v-if="!isNil(judgment.judgmentDate)" class="text-minimum-gray">
              {{ $cove.formatDate(judgment.judgmentDate) }}
            </div>
          </dd>
        </template>
      </dl>
    </v-card-text>
    <v-card-actions class="justify-end mt-5">
      <c-btn type="primary" @click="save">
        {{ $t('global.finish') }}
      </c-btn>
      <c-btn @click="$emit('back')">
        {{ $t('global.back') }}
      </c-btn>
      <c-btn @click="$emit('cancel')">
        {{ $t('global.cancel') }}
      </c-btn>
    </v-card-actions>
  </c-loading-area>
</template>

<script>
import _ from 'lodash';
import WorkflowStepMixin from '@/mixins/workflowStep';
import { generateJudgmentText } from '@/application/utility';

export default {
  components: { },
  mixins: [ WorkflowStepMixin ],
  data () {
    return {
    };
  },
  computed: {
    hasCaseTitle () {
      return !_.isNil(this.bean.case.caseTitle);
    },
    hasJudgments () {
      return !_.isEmpty(this.bean.judgments);
    }
  },
  methods: {
    generateJudgmentText,
    save () {
      this.$emit('save');
    },
    hasJudgmentText (judgment) {
      return !_.isNil(judgment.judge) || !_.isNil(this.getJudgmentTypeName(judgment));
    },
    getJudgmentTypeName (judgment) {
      return _.get(judgment, 'judgmentType.judgmentTypeValue', null);
    }
  }
};
</script>